/**
 * Sales put on hold at this till.
 *
 * Hold used to send the basket to the server and clear the screen, and nothing
 * on the till ever brought it back — a held sale was gone as far as the
 * cashier was concerned, and with no signal Hold failed outright. A held basket
 * now waits here, on the till that held it, and is resumed from the Held list.
 * It is not a sale yet, so nothing is queued; it becomes one when it is paid.
 */

import { db } from "@/db/database";
import type { HeldSale } from "@/db/schema";

import { authRepository } from "./authRepository";

export type { HeldSale };

export const heldSaleRepository = {
  async hold<Line extends object>(input: {
    lines: Line[];
    total: number;
    itemCount: number;
  }): Promise<HeldSale> {
    const createdAt = new Date();
    const held: HeldSale = {
      id: crypto.randomUUID(),
      label: createdAt.toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" }),
      createdAt: createdAt.toISOString(),
      cashierId: await authRepository.cashierId(),
      lines: input.lines as unknown as Record<string, unknown>[],
      total: input.total.toFixed(2),
      itemCount: input.itemCount,
    };
    await db.heldSales.add(held);
    return held;
  },

  /** Oldest first: the customer who has waited longest is served first. */
  list(): Promise<HeldSale[]> {
    return db.heldSales.orderBy("createdAt").toArray();
  },

  /** Take a held basket back off the shelf. Gone from the list once resumed. */
  async resume<Line>(id: string): Promise<Line[] | null> {
    const held = await db.heldSales.get(id);
    if (!held) return null;
    await db.heldSales.delete(id);
    return held.lines as unknown as Line[];
  },

  async discard(id: string): Promise<void> {
    await db.heldSales.delete(id);
  },
};
